module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "test-container"
  }, [_c('div', {
    staticClass: "left-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-main"
  }, [_c('el-form', {
    ref: "printTestForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rule,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备编号：",
      "prop": "imei",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入打印设备编号(SN)"
    },
    model: {
      value: (_vm.form.imei),
      callback: function($$v) {
        _vm.$set(_vm.form, "imei", $$v)
      },
      expression: "form.imei"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单编号："
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 64,
      "placeholder": "选填，可输入订单编号，长度不能超过64"
    },
    model: {
      value: (_vm.form.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderNo", $$v)
      },
      expression: "form.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "延迟打印："
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "label": "描述文字"
    },
    model: {
      value: (_vm.form.delay),
      callback: function($$v) {
        _vm.$set(_vm.form, "delay", $$v)
      },
      expression: "form.delay"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "delay-tips"
  }, [_vm._v("（选填，默认 0 表示立即打印，单位：秒）")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "打印内容：",
      "prop": "content",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "2500",
      "show-word-limit": "",
      "rows": 12,
      "placeholder": "请输入打印内容，可根据右侧标签进行组合"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.handleTest
    }
  }, [_vm._v("立即提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重新填写")])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "right-container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tags-container"
  }, _vm._l((_vm.$printTags), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tags"
    }, [_c('div', {
      staticClass: "tag-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "tag-tips"
    }, [_vm._v(_vm._s(item.tips))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-title"
  }, [_c('div', {
    staticClass: "iconfont icon-dayinji"
  }), _vm._v(" "), _c('div', {
    staticClass: "div-label"
  }, [_vm._v("打印测试表单")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-tips"
  }, [_c('div', {
    staticClass: "top-tips-label"
  }, [_vm._v("说明：")]), _vm._v(" "), _c('div', [_vm._v("打印前请务必保证打印机正常在线，如不能成功打印，可微信咨询技术客服。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-title"
  }, [_c('div', {
    staticClass: "iconfont icon-biaoqian"
  }), _vm._v(" "), _c('div', {
    staticClass: "div-label"
  }, [_vm._v("打印标签")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45a3d86f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/printTest.vue
// module id = 334
// module chunks = 1